<template>
  <div :class="bodyClass">
     <router-view class=""/>
  </div>
</template>
<script>
export default {
  name: 'home',

  computed: {
    bodyClass () {
      if (this.$route.meta.bodyClass !== undefined) return this.$route.meta.bodyClass
      return null
    }
  }
}
</script>
